import { render } from "./PreciosView.vue?vue&type=template&id=01897e3a&scoped=true"
import script from "./PreciosView.vue?vue&type=script&lang=js"
export * from "./PreciosView.vue?vue&type=script&lang=js"

import "./PreciosView.vue?vue&type=style&index=0&id=01897e3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01897e3a"]])

export default __exports__